import React from 'react'

const Radio = ({name, className,onChange, value, checked, id}) => {
  return (
    <input value={value} onChange={onChange} checked={checked} className={`radio ${className && className}`} type="radio" name={name} id={id} />
  )
}

export default Radio